<ng-template #step1>
  @if (!loadingData() && availablePorts().length === 0) {
    <div
      class="dialog__body dialog__body--grow dialog__body--grey dialog__body--center selfservice-add-port__empty-state"
    >
      <div class="selfservice-loader" style="max-width: 340px">
        <img src="assets/images/ports-illustration.svg" alt="" />
        <h3 class="selfservice-loader__title">{{ "Selfservice.AddPort.EmptyTitle" | translate }}</h3>
        <p>{{ "Selfservice.AddPort.EmptyText" | translate }}</p>
      </div>
    </div>
  } @else {
    <div
      class="dialog__body dialog__body--scroll dialog__body--flex-justify dialog__body--no-padding dialog__body--grow dialog__body--grey"
    >
      <div class="dialog__inner">
        <h3 class="dialog__sub-heading">{{ "Selfservice.AddPort.Subheading" | translate }}</h3>
        <p class="no-margin">{{ "Selfservice.AddPort.Text" | translate }}</p>
      </div>
      <div>
        @if (loadingData()) {
          <div>
            <loader />
          </div>
        }
        @for (port of availablePorts(); track $index) {
          <div class="selfservice-add-port__bar">
            <div class="selfservice-add-port__left">
              <div class="selfservice-add-port__details" [class.active]="port.selected">
                <div class="selfservice-add-port__icon-box">
                  <svg-icon src="assets/images/icons/port.svg"></svg-icon>
                </div>
                <div>
                  <h3>{{ port.customerDescription }}</h3>
                  <div class="selfservice-add-port__meta">
                    {{ port.customer.fullname }}, {{ port.address.city }} ({{ port.address.street }}),
                    {{ port.subscriptionId | shorten_guid }}
                  </div>
                </div>
              </div>
            </div>
            <div class="selfservice-add-port__right">
              <div class="selfservice-add-port__toggle">
                <input
                  [id]="'toggle-' + $index"
                  type="checkbox"
                  [checked]="port.selected"
                  (change)="togglePort(port)"
                />
                <label [for]="'toggle-' + $index">
                  <selfservice-toggle [active]="port.selected"></selfservice-toggle>
                </label>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #step2>
  <div
    class="dialog__body dialog__body--scroll dialog__body--flex-justify dialog__body--no-padding dialog__body--grow dialog__body--grey"
  >
    <div class="dialog__inner">
      <h3 class="dialog__sub-heading">{{ "Selfservice.AddPort.Subheading2" | translate }}</h3>
      <p class="no-margin">{{ "Selfservice.AddPort.Text2" | translate }}</p>
    </div>
    @for (port of selectedPorts(); track $index) {
      <div class="selfservice-add-port__bar">
        <div class="selfservice-add-port__left">
          <div class="selfservice-add-port__details" [class.active]="port.selected">
            <div class="selfservice-add-port__icon-box">
              <svg-icon src="assets/images/icons/port.svg"></svg-icon>
            </div>
            <div>
              <h3>{{ port.customerDescription }}</h3>
              <div class="selfservice-add-port__meta">
                {{ port.customer.fullname }}, {{ port.address.city }} ({{ port.address.street }}),
                {{ port.subscriptionId | shorten_guid }}
              </div>
            </div>
          </div>
          <div class="selfservice-add-port__left-bottom">
            <div>{{ "Selfservice.AddPort.NotAvailableVlans" | translate }}</div>
            <ul class="selfservice-add-port__tags">
              @for (v of port.usedVlans; track $index) {
                <li>{{ v }}</li>
              }
            </ul>
          </div>
        </div>
        <div class="selfservice-add-port__right">
          <div class="selfservice-add-port__form">
            <label>{{ "Selfservice.AddPort.NewVlan" | translate }}</label>
            <input type="string" [(ngModel)]="port.vlan" [class.error]="port.vlan && !validVlan(port, port.vlan)" />
          </div>
          @if (port.vlan && !validVlan(port, port.vlan)) {
            <div class="red" style="font-size: 12px">
              {{ "Selfservice.AddPort.VlanInUse" | translate }}
              <br />
              <br />
            </div>
          }
          <p class="selfservice-add-port__footnote">{{ "Selfservice.AddPort.VlanHint" | translate }}</p>
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #step3>
  <div
    class="dialog__body dialog__body--scroll dialog__body--flex-justify dialog__body--no-padding dialog__body--grow dialog__body--grey"
  >
    <div class="dialog__inner">
      <h3 class="dialog__sub-heading">{{ "Global.Summary" | translate }}</h3>
      <p class="no-margin t-newline">{{ "Selfservice.AddPort.SummaryText" | translate }}</p>
    </div>

    <div class="selfservice-add-port__summary">
      <div class="selfservice-add-port__summary-item">
        <div class="selfservice-add-port__summary-top" (click)="toggleSummaryItemOne()">
          <div class="selfservice-add-port__summary-top-left">{{ "Selfservice.AddPort.AddedPorts" | translate }}</div>
          <div class="selfservice-add-port__summary-top-right">
            <div>{{ "Selfservice.IPP.Total" | translate }}</div>
            <div>{{ selectedPorts().length }}</div>
            <svg-icon src="assets/images/icons/chevron-down.svg" [class.active]="summaryItemOneExpanded()"> </svg-icon>
          </div>
        </div>
        @if (summaryItemOneExpanded()) {
          <div class="selfservice-add-port__summary-expand">
            <ul class="selfservice-add-port__list">
              @for (port of selectedPorts(); track $index) {
                <li class="selfservice-add-port__list-item selfservice-add-port__list-item--green">
                  <svg-icon src="assets/images/icons/+.svg"></svg-icon>
                  <div>
                    <div class="selfservice-add-port__list-title">{{ port.customerDescription }}</div>
                    <div>
                      {{ port.subscriptionId | shorten_guid }} - {{ port.customer.fullname }},
                      {{ port.address.city }} ({{ port.address.street }}), VLAN {{ port.vlan }}
                    </div>
                  </div>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>

    <div class="selfservice-add-port__summary">
      <div class="selfservice-add-port__summary-item">
        <div class="selfservice-add-port__summary-top" (click)="toggleSummaryItemTwo()">
          <div class="selfservice-add-port__summary-top-left">
            {{ "Selfservice.AddPort.AlreadyLinkedPorts" | translate }}
          </div>
          <div class="selfservice-add-port__summary-top-right">
            <div>{{ "Selfservice.IPP.Total" | translate }}</div>
            <div>{{ nrOfEsis() }}</div>
            <svg-icon src="assets/images/icons/chevron-down.svg" [class.active]="summaryItemTwoExpanded()"> </svg-icon>
          </div>
        </div>

        @if (summaryItemTwoExpanded()) {
          <div class="selfservice-add-port__summary-expand">
            <ul class="selfservice-add-port__list">
              @for (item of esis(); track $index) {
                <li class="selfservice-add-port__list-item selfservice-add-port__list-item--purple">
                  @if (item.endpoints?.length === 1) {
                    <div class="selfservice-add-port__list-item-inner">
                      <svg-icon src="assets/images/icons/port.svg"></svg-icon>
                      <div>
                        <div class="selfservice-add-port__list-title">
                          {{ item.endpoints![0].port?.customerDescription }}
                        </div>
                        <div>
                          {{ item.endpoints![0].port?.subscriptionId | shorten_guid }} -
                          {{ item.endpoints![0].port?.customer?.fullname }},
                          {{ item.endpoints![0].port?.address?.city }} ({{ item.endpoints![0].port?.address?.street }}),
                          VLAN {{ item.endpoints![0].vlanrange }}
                        </div>
                      </div>
                    </div>
                  }
                  @if ((item.endpoints?.length ?? 0) > 1) {
                    <div class="selfservice-add-port__list-item-multihome">
                      <div class="selfservice-add-port__list-item-multihome-title">
                        {{ "Selfservice.MulthomedInterface" | translate }}
                      </div>
                      @for (subitem of item.endpoints; track $index) {
                        <div class="selfservice-add-port__list-item-inner">
                          <svg-icon src="assets/images/icons/port.svg"></svg-icon>
                          <div>
                            <div class="selfservice-add-port__list-title">{{ subitem.port?.customerDescription }}</div>
                            <div>
                              {{ subitem.port?.subscriptionId | shorten_guid }} -
                              {{ subitem.port?.customer?.fullname }}, {{ subitem.port?.address?.city }} ({{
                                subitem.port?.address?.street
                              }}), VLAN
                              {{ subitem.vlanrange }}
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>

<selfservice-wizard
  [steps]="[step1, step2, step3]"
  [getCommand]="buildCommand"
  [bus]="bus()"
  [canContinue]="stepCanContinue"
/>
